module.exports = __webpack_public_path__ + "static/OneDot.9d8a1c7a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot.woff2
// module id = 737
// module chunks = 114276838955818